<template>
  <div class="entire-bd tb" v-if="funcView.entire_list">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item style="float: right; margin-right: 0">
          <custom-column :code="tableCode" v-model="tableColumn"></custom-column>
        </el-form-item>
        <!-- <el-form-item style="float: right;" v-if="funcView.entire_export">
          <el-button class="table-set" style="vertical-align: top;" @click="exportTable('modemBatteryExport', formSearch)">
            <i class="icon icon-daochu"></i>
          </el-button>
        </el-form-item> -->
        <el-form-item style="float: right" v-if="funcView.entire_export">
          <el-button class="table-set" style="vertical-align: top" @click="exportTable('modemBatteryExport', formSearch)">
            <i class="icon icon-daochu"></i>
          </el-button>
        </el-form-item>
        <el-form-item style="float: right">
          <search-input :placeholder="$t('dms_entire.ModemSNdcSNcpSN')" v-model="formSearch.search" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <switch-button :link="link"></switch-button>
        </el-form-item>
        <el-radio-group style="float: right; margin-right: 8px" v-model="formSearch.testState" @change="onPageChange({ page: 1 })">
          <el-radio-button :label="item.value" v-for="(item, index) in testStateData" :key="index">{{ item.name }}</el-radio-button>
        </el-radio-group>
      </el-form>
    </div>
    <switch-container ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter()">
      <el-form :inline="true" label-position="top">
        <el-form-item label="IMSI">
          <el-input v-model="formSearch.imsi" placeholder="" style="width: 100%" clearable></el-input>
        </el-form-item>
        <el-form-item label="ICCID">
          <el-input v-model="formSearch.iccid" placeholder="" style="width: 100%" clearable></el-input>
        </el-form-item>
        <el-form-item label="IMEI">
          <el-input v-model="formSearch.simImei" placeholder="" style="width: 100%" clearable></el-input>
        </el-form-item>
        <el-form-item :label="$t('dms_entire.ISTzhan_dian')">
          <custom-select
            v-model="formSearch.websiteName"
            filterable
            url="websiteSelectList"
            :model="formSearch"
            :params="{ websiteEnv: this.websiteEnv, websiteType: 1 }"
            :props="{ label: 'websiteName', value: 'websiteName', map: { websiteCode: 'websiteCode' } }"
            width="100%"
          ></custom-select>
        </el-form-item>
        <el-form-item :label="$t('dms_entire.chan_pin_xing_hao')">
          <custom-select
            url="productCodeSelectList"
            v-model="formSearch.productCode"
            :listener="formSearch.websiteCode"
            :params="{ websiteCode: formSearch.websiteCode }"
            :props="{ label: 'productCode', value: 'productCode' }"
            width="100%"
          ></custom-select>
        </el-form-item>
        <el-form-item :label="$t('dms_entire.xie_yi')">
          <el-input v-model="formSearch.protocolCode" placeholder="" style="width: 100%"></el-input>
        </el-form-item>
        <el-form-item :label="$t('dms_entire.sheng_yu_dian_liang')">
          <input-range v-model="formSearch.batteryCharge" type="number" style="width: 100%" />
        </el-form-item>
        <el-form-item :label="$t('dms_entire.geng_xin_shi_jian')">
          <custom-date-picker style="width: 100%" v-model="formSearch.dataTimes" type="daterange" value-format="YYYY-MM-DD HH:mm:ss" :picker-options="beforeToday"></custom-date-picker>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table
        height="100%"
        :index="true"
        :data="tableList"
        :loading="isLoading"
        :column="tableColumn"
        @sort="sortChange"
        @filter="filterChange"
        :slots="['modemSn', 'protocolCode', 'action', 'websiteName','networkType','cellularMode','dbm']"
      >
        <template v-slot:websiteName="scope">{{ getWebsiteName(scope.row) }}</template>
        <template slot="modemSn" slot-scope="scope">
          <span
            v-if="funcView.entire_modem_detail"
            class="cell-link"
            @click="jump('/redirect/boarddetail', { deviceId: scope.row.deviceId, modemSn: scope.row.modemSn, type: 'entire', testType: formSearch.testType, parentPath: $route.path })"
          >
            {{ scope.row.modemSn }}
          </span>
          <span v-else>{{ scope.row.modemSn }}</span>
        </template>
        <template slot="protocolCode" slot-scope="scope">
          <span>{{ scope.row.protocolCode || '-' }}/{{ scope.row.tcpVersion || '-' }}</span>
        </template>
                <template v-slot:networkType="scope">
          <div v-if="`${scope.row.isOnline}` === '1'">{{ getDicValue('dms_device_network_type', scope.row.networkType) || '-'  }}</div>
          <div v-else>{{ '-' }}</div>
        </template>
        <template v-slot:cellularMode="scope">
          <div v-if="`${scope.row.isOnline}` === '1'">{{ getDicValue('dms_device_cellular_mode', scope.row.cellularMode) || '-'}}</div>
          <div v-else>{{ '-' }}</div>
        </template>
        <template v-slot:dbm="scope">
          <div v-if="`${scope.row.isOnline}` === '1'">{{ scope.row.dbm || '-' }}</div>
          <div v-else>{{ '-' }}</div>
        </template>
        <template slot="action" slot-scope="scope">
          <el-button type="text" size="mini" v-if="funcView.entire_edit" @click="onEdit(scope.row)">{{ funcView.entire_edit }}</el-button>
          <!-- 测试按钮显示条件：站点状态必须是是已设置 -->
          <el-button type="text" size="mini" v-if="['0', '100'].includes(formSearch.testState) && funcView.entire_test && `${scope.row.websiteState}` === '9'" @click="onTesting(scope.row)">
            {{ funcView.entire_test }}
          </el-button>
          <el-button type="text" size="mini" v-if="formSearch.testState === '10' && !scope.row.bodyNum && funcView.entire_warehousing" @click="onWarehousing(scope.row)">
            {{ funcView.entire_warehousing }}
          </el-button>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
    <!-- 入库 -->
    <device-ware-housing-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="getTableList"></device-ware-housing-dialog>
    <!-- 测试 -->
    <device-test-dialog v-if="dialogVisible1" :model="dialogModel1" @close="dialogVisible1 = false" @success="getTableList"></device-test-dialog>
    <!-- 编辑 -->
    <entireItem-dialog v-if="dialogVisible2" :model="dialogModel2" @close="dialogVisible2 = false" @success="getTableList"></entireItem-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins';
import inputRange from '@/components/inputRange';
import deviceTestDialog from '@/pages/dms/components/device_test_dialog.vue';
import deviceWareHousingDialog from './children/device_warehousing_dialog.vue';
import entireItemDialog from './children/entire_Item_dialog.vue';

export default {
  mixins: [resetFormSearchMixins],
  name: 'entire',
  components: {
    deviceWareHousingDialog,
    deviceTestDialog,
    inputRange,
    entireItemDialog,
  },
  computed: {
    testStateData() {
      // return this.propertyMap.dms_test_state.filter(i => i.code !== 'confirming');
      return this.propertyMap.dms_test_state;
    },
  },
  data() {
    return {
      provide: true,
      tableCode: 'factoryTest_entire',

      formSearch: {
        testState: '0',
        testType: '9', // 测试类型:1-电池，9-整机
        search: '',
        orderBy: '',
        orderType: '',
        imsi: '',
        iccid: '',
        simImei: '',
        pageSize: 50,
        pageNum: 1,
        productCode: '',
        beginOfModified: '',
        endOfModified: '',
        dataTimes: '',
        websiteName: '',
        websiteCode: '',
        protocolCode: '',
        batteryCharge: [],
      },
      tableList: [],
      totalRows: 0,
      dialogVisible: false,
      dialogModel: {},
      dialogVisible1: false,
      dialogModel1: {},
      dialogVisible2: false,
      dialogModel2: {},
      link: null,
      isLoading: false,
      // IST 站点列表
      istList: [],
    };
  },
  activated: function () {
    this.getTableList();
  },
  mounted: function () {
    this.isLoading = true;
    this.getDictionary('dms_test_state');
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getFuncView(null, () => {
      setTimeout(() => {
        this.link = this.$refs.container;
      }, 500);
    });
    this.initIstList();

    this.getTableColumn();
  },
  methods: {
    initIstList() {
      const reqUrl = apis.websiteSelectList;
      const reqData = { websiteEnv: this.websiteEnv, websiteType: 1 };
      this.$getJSON(reqUrl, reqData).then((res) => {
        this.istList = res.data || [];
      });
    },
    getWebsiteName(row) {
      const istList = this.istList;
      if (istList.length) {
        const item = istList.find((obj) => obj.websiteCode === row.websiteCode);
        if (item) {
          return item.websiteName;
        }
      }
      return row.websiteName || '-';
    },

    // 获取列表
    getTableList() {
      this.isLoading = true;
      this.tableList = [];
      this.formSearch.beginOfModified = this.formSearch.dataTimes ? this.formSearch.dataTimes[0] : '';
      this.formSearch.endOfModified = this.formSearch.dataTimes ? this.formSearch.dataTimes[1] : '';
      this.formSearch.beginOfBatteryCharge = this.formSearch.batteryCharge ? this.formSearch.batteryCharge[0] : '';
      this.formSearch.endOfBatteryCharge = this.formSearch.batteryCharge ? this.formSearch.batteryCharge[1] : '';
      this.$getJSON(apis.modemBatteryPage, this.formSearch).then((res) => {
        this.isLoading = false;
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    // 测试
    onTesting(row) {
      this.dialogModel1.title = this.$t('dms_entire.zheng_ji_ce_shi');
      this.dialogModel1.data = row;
      this.dialogModel1.data.testType = this.formSearch.testType;
      this.dialogVisible1 = true;
    },
    // 入库
    onWarehousing(row) {
      this.dialogModel.title = this.$t('dms_entire.rkgccpc');
      this.dialogModel.data = row;
      this.dialogVisible = true;
    },
    // 编辑
    onEdit(row) {
      this.dialogModel2.title = this.$t('Common.com_edit');
      this.dialogModel2.type = 'edit';
      this.dialogModel2.data = row;
      this.dialogVisible2 = true;
    },
  },
};
</script>
